/**
 * The smallest possible class-name joiner. `clsx`/`classnames` would be a new
 * pinned dependency for nine lines of code; this is that code.
 */
export function cx(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
